export default "__VITE_ASSET__BpBocRDs__"